import React from "react"

// styles
import "@/assets/scss/pages/analytics.scss"

// providers
import { trans } from "@/_providers/Translation"

// components
import PrevRepairTasks from "./partials/PrevRepairTasks"
import DelayedAddresses from "./partials/DelayedAddresses"
import RepairsIncomesRatio from "./partials/RepairsIncomesRatio"
import EmployeesRating from "./partials/EmployeesRating"
import ResolvedTickets from "./partials/ResolvedTickets"
import AverageRepairTime from "./partials/AverageRepairTime"

function Technicians() {
  return (
    <div id="analytics-technicians">
      <div className="top-part">
        <div className="left">
          <h1 className="page-heading">{trans("nav.analytics_technicians")}</h1>
          <p className="page-subheading">
            lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <PrevRepairTasks />
          </div>
        </div>
        <div className="col">
          <div className="pannel">
            <DelayedAddresses />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <RepairsIncomesRatio />
          </div>
        </div>
        <div className="col">
          <div className="pannel">
            <EmployeesRating />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <AverageRepairTime />
          </div>
        </div>
        <div className="col">
          <div className="pannel">
            <ResolvedTickets />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Technicians
